import md5 from 'js-md5'
import axios from 'axios'
import { Loading } from 'element-ui'

/**
 * 组合使用
 * @param { Object } config  判断条件回调
 * @return { String }
 */
export const uploadFileEvent = config => {
	return new Promise((resolve, reject) => {
		const input = document.createElement('input')
		input.type = 'file'
		if (config.accept) {
			input.accept = config.accept
		}
		input.onchange = async () => {
			const file = input.files[0]
			let flag = await beforeUpload(file, config)
			if (flag) {
				if (config?.api) {
					let data = await httpRequest(file, config.api)
					resolve(data)
				} else {
					resolve(file)
				}
			}
		}
		input.oncancel = () => {
			reject()
			throw new Error('取消上传')
		}
		input.onerror = () => {
			reject()
			throw new Error('上传出错~')
		}
		input.click()
	})
}

/**
 * url链接展示文件墙
 * @param { Array } fileUrl url链接数组
 * @return { Array<Object> } 数组
 */
export const fileUrlToBase64 = fileUrl => {
	return fileUrl.map(item => {
		let filename = item.split('/')?.pop() || '*' // 从 URL 中获取文件名
		let blobUrl = URL.createObjectURL(new Blob([''], { type: '' })) // 创建一个 Blob 对象并获取 URL
		return {
			name: filename,
			url: blobUrl
		}
	})
}
/**
 * 上传校验
 * @param { String, Object } file params  二进制 | 回调
 * @return { Boolean }
 */
export const beforeUpload = async (file, params = {}) => {
	const defaultParams = {
		maxSize: 2000,
		suceessCallback: () => {
			return new Promise(resolve => {
				resolve(`成功`)
			})
		},
		errorCallback: () => {
			return new Promise(resolve => {
				resolve(`上传图片大小不能超过${200}KB!`)
			})
		},
		doneCallback: () => {
			return new Promise(resolve => {
				resolve(`完成`)
			})
		}
	}
	const { maxSize, suceessCallback, errorCallback, doneCallback } = Object.assign(params, defaultParams)
	let flag
	if (file.size / 1024 / 1024 > maxSize) {
		errorCallback && (await errorCallback())
		flag = false
	} else {
		suceessCallback && (await suceessCallback())
		flag = true
	}
	doneCallback && doneCallback()
	return flag
}
/**
 *
 * @param { String } file  二进制
 * @return { Promise }
 */
export function readBlobAsArrayBuffer(file) {
	return new Promise(resolve => {
		const reader = new window.FileReader()
		reader.onload = event => resolve(event.target.result)
		reader.readAsArrayBuffer(file)
	})
}
/**
 * 上传方法
 * @param { String } file  二进制
 * @return { Promise }
 */
export const httpRequest = async (file, api) => {
	const loadng = Loading.service({ text: '正在上传图片' })
	try {
		let rf = await readBlobAsArrayBuffer(file)
		const MD5 = md5(rf)
		const data = await api({
			file_key: 'file',
			filename: file.name,
			hash: MD5,
			mime_type: file.type,
			size: file.size,
			storage: {
				channel: 'public'
			}
		})
		let fileUrl
		if (file.size / 1024 / 1024 > 2000) {
			let form = new FormData()
			form.append('file', file.file)
			fileUrl = await uploadFileForm(data.uri, form, {
				...data.headers
			})
		} else {
			fileUrl = await uploadFile(data.uri, rf, {
				...data.headers
			})
		}
		loadng.close()
		return fileUrl
	} catch (err) {
		loadng.close()
	}
}

const uploadFileForm = async (url, args, config) => {
	let res = await axios.post(url, args, {
		headers: {
			'Content-Type': 'multipart/form-data',
			...config
		}
	})
	return res.data
}
const uploadFile = async (url, args, config) => {
	let res = await axios.put(url, args, {
		headers: {
			'Content-Type': 'multipart/form-data',
			...config
		}
	})
	return res.data
}
